import { PageHeader } from '../../../components/states';
import { NotificationList } from './NotificationList';

/** `/notifications`: the signed-in user's inbox (the top-bar bell can link here). */
export function NotificationsPage() {
  return (
    <>
      <PageHeader title="Notifications" subtitle="Reminders and alerts sent to you." />
      <NotificationList />
    </>
  );
}
